import { call, put, takeLatest } from 'redux-saga/effects';
import {
    RESET_PASSWORD_USER,
    resetedPasswordUser,
    SEND_AUTHENTICATION_CODE,
    sentAuthenticationCodeUser,
    REQUEST_USER_CODES,
    loadedUserCodes,
} from '../actions/users.action';

import {Users} from '../api/index';
import { toast } from "react-toastify";

export function* resetPasswordUser(payload) {
    try {
        let token = yield call(() => Users.resetPasswordToken(payload));
        yield put(resetedPasswordUser(token.data));
        toast.success('Lien généré');
    } catch (err) {
        toast.error(err.response.data.message);
    }
}

export function* requestUserCodes({payload}) {
    try {
        let codes =yield call(() => Users.codes(payload));
        yield put(loadedUserCodes(codes.data));
    } catch (err) {
        toast.error(err.response.data.message);
    }
}


export function* sendAuthenticationCodeUser({payload}) {
    try {
        let code =yield call(() => Users.sendAuthenticationCode(payload));
        yield put(sentAuthenticationCodeUser(code.data));
    } catch (err) {
        toast.error(err.response.data.message);
    }
}

export function* watchResetPasswordUser() {
    yield takeLatest(RESET_PASSWORD_USER, resetPasswordUser)
}

export function* watchSendAuthenticationCodeUser() {
    yield takeLatest(SEND_AUTHENTICATION_CODE, sendAuthenticationCodeUser)
}

export function* watchRequestUserCodes() {
    yield takeLatest(REQUEST_USER_CODES, requestUserCodes);
}


// WEBPACK FOOTER //
// ./src/sagas/users.saga.js